<template>
  <label class="cursor-pointer inline-flex items-center">
    <input
      type="checkbox"
      class="hidden"
      :checked="modelValue"
      @change="$emit('update:modelValue', !modelValue)"
    />
    <div
      class="w-5 h-5 rounded-md flex items-center justify-center border border-brand-primary/10"
      :class="modelValue ? 'bg-brand-primary' : 'bg-gray-500/20'"
    >
      <Icon
        v-if="modelValue"
        name="fa6-solid:check"
        class="text-white text-xss"
      />
    </div>
  </label>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})
defineEmits(['update:modelValue'])
</script>
